module.exports = __webpack_public_path__ + "static/img/logo_n.b471154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo_n.png
// module id = c75H
// module chunks = 0